export default __webpack_public_path__ + "static/media/geometry-artwork-6.6290d514.jpg";